import React from 'react'
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer';

const Card = ({icon, title, description, className}) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: .8 })

  const variants = {
      visible: { y: '0px', opacity: 1, transition: { type: 'spring', duration: 1 } },
      hidden: { y: '20px', opacity: 0 }
  };

  return (
      <motion.div
          ref={ref}
          variants={variants}
          animate={inView ? 'visible' : 'hidden'}
          initial='hidden'
          className={`py-10 px-8 border border-purple_light rounded-[12px] shadow-cardShadow items-center ${className}`}
      >
          <div>{icon}</div>
          <div className='mt-4'>
              <p className='text-20 font-dmsans_b leading-7 text-dark_blue mb-[8px]'>{title}</p>
              <p className='mt-3 text-16 font-dmsans_r leading-6 text-[#8F8E9B]'>{description}</p>
          </div>
      </motion.div>
  );
}

export default Card